export enum DeletedItemStyleClass {
  DRAFT = 'delete-draft-article',
  ARTICLE = 'delete-article',
  MEETING = 'delete-meeting',
  WORKSPACE = 'delete-workspace',
  GROUP = 'delete-group',
  COMMENT = 'delete-comment',
}
